import { useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { Input } from 'components/ideal-core-ui'
import s from './EditItemModal.scss'

const EditItemModal = ({ toggleEditItemModal, isEditItemModalVisible, editedItem, updateItem }) => {
  const [name, setName] = useState(editedItem.label)

  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={isEditItemModalVisible}
        toggle={toggleEditItemModal}
        size="md"
      >
        <ModalHeader toggle={toggleEditItemModal} className={s.modalHeader}>
          Edit Name
        </ModalHeader>
        <ModalBody>
          <Input
            type="text"
            onChangeCb={() => setName(event.target.value)}
            text={name}
            placeholder="Enter Name"
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleEditItemModal}>
            Cancel
          </Button>
          <Button
            className={s.saveBtn}
            onClick={() => {
              updateItem(name)
              toggleEditItemModal()
            }}
            disabled={name === ''}
          >
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default EditItemModal
